// Vendors
import { TrackingEventsEnum, TrackingLinkEventReturnType } from '@openbank/ziniaweb-ui-core-models';
// Types
import { ConsentsCheckboxChangeTrackingBuilder } from '../../pre-contractual/handlers/types/pre-contract.view.handlers.types';
import { ContractualTrackingHandlersType } from './types/contract.view.tracking.handlers.type';
import { TrackBuilderType } from 'types/track-builder.type';
// Utils
import { isSepaConsent } from './utils/contract.view.handlers.utils';

const continueButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'continue',
    format: 'button',
    component: 'form',
    element: 'continue',
    pathname: '/',
    eventCategory: 'Contract',
    eventAction: 'clickButton',
    eventLabel: 'continueButton',
  },
  type: TrackingEventsEnum.LINK,
});

const downloadPdfButtonClickTracking = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'download',
    format: 'link',
    component: 'form',
    element: 'termsAndConditions',
    pathname: '/',
    eventCategory: 'Contract',
    eventAction: 'clickLink',
    eventLabel: 'termsAndConditionsLink',
  },
  type: TrackingEventsEnum.LINK,
});

const consentCheckboxChangeTracking = ({
  checked,
  type,
}: ConsentsCheckboxChangeTrackingBuilder): TrackingLinkEventReturnType => {
  return {
    payload: {
      action: checked ? 'check' : 'uncheck',
      format: 'checkBox',
      component: 'form',
      element: isSepaConsent(type) ? 'SEPA' : 'consents',
      eventCategory: 'Contract',
      eventAction: 'clickCheckBox',
      eventLabel: `${isSepaConsent(type) ? 'SEPA' : 'consents'}${checked ? 'check' : 'uncheck'}`,
    },
    type: TrackingEventsEnum.LINK,
  };
};

const ContractViewTrackingHandlers = (
  track: TrackBuilderType
): ContractualTrackingHandlersType => ({
  handleContinueButtonClickTracking: () => track(continueButtonClickTracking()),
  handleDownloadPdfButtonClickTracking: () => track(downloadPdfButtonClickTracking()),
  handleConsentsCheckboxChangeTracking: ({
    checked,
    type,
  }: ConsentsCheckboxChangeTrackingBuilder) =>
    track(consentCheckboxChangeTracking({ checked, type })),
});

export { ContractViewTrackingHandlers };
